export const isPositive = (value: number) => {
  return value > 0 ? true : false;
};

export const leverageColorCode = (
  heatMapActive: boolean,
  params: any,
  topCompare: any,
  medianCompare: any,
  bottomCompare: any
) => {
  if (heatMapActive) {
    if (params.value && isPositive(topCompare) && isPositive(medianCompare) && isPositive(bottomCompare)) {
      if (isPositive(params.value)) {
        return colorCode(heatMapActive, params, topCompare, medianCompare, bottomCompare);
      } else {
        return 'heatmap-cell-red';
      }
    } else if (params.value && !isPositive(topCompare)) {
      if ((topCompare && params.value <= topCompare) || params.value > 0) {
        return 'heatmap-cell-green';
      } else if (topCompare && medianCompare && params.value > topCompare && params.value <= medianCompare) {
        return 'heatmap-cell-yellow-green';
      } else if (bottomCompare && medianCompare && params.value > medianCompare && params.value <= bottomCompare) {
        return 'heatmap-cell-yellow';
      } else if (bottomCompare && params.value > bottomCompare && params.value <= 0) {
        return 'heatmap-cell-red';
      }
    } else if (params.value && !isPositive(medianCompare)) {
      if (topCompare && params.value <= topCompare && params.value > 0) {
        return 'heatmap-cell-green';
      } else if ((topCompare && medianCompare && params.value > topCompare) || params.value <= medianCompare) {
        return 'heatmap-cell-yellow-green';
      } else if (bottomCompare && medianCompare && params.value > medianCompare && params.value <= bottomCompare) {
        return 'heatmap-cell-yellow';
      } else if (bottomCompare && params.value > bottomCompare && params.value <= 0) {
        return 'heatmap-cell-red';
      }
    } else if (params.value && !isPositive(bottomCompare)) {
      if (topCompare && params.value <= topCompare && params.value > 0) {
        return 'heatmap-cell-green';
      } else if (topCompare && medianCompare && params.value > topCompare && params.value <= medianCompare) {
        return 'heatmap-cell-yellow-green';
      } else if ((bottomCompare && medianCompare && params.value > medianCompare) || params.value <= bottomCompare) {
        return 'heatmap-cell-yellow';
      } else if (bottomCompare && params.value > bottomCompare && params.value <= 0) {
        return 'heatmap-cell-red';
      }
    }
  }
  return '';
};

export const colorCode = (
  heatMapActive: boolean,
  params: any,
  topCompare: any,
  medianCompare: any,
  bottomCompare: any
) => {
  if (heatMapActive) {
    if ((params.value || params.value == 0) && bottomCompare > topCompare) {
      if (topCompare && params.value <= topCompare) {
        return 'heatmap-cell-green';
      } else if (topCompare && medianCompare && params.value > topCompare && params.value <= medianCompare) {
        return 'heatmap-cell-yellow-green';
      } else if (bottomCompare && medianCompare && params.value <= bottomCompare && params.value > medianCompare) {
        return 'heatmap-cell-yellow';
      } else if (bottomCompare && params.value > bottomCompare) {
        return 'heatmap-cell-red';
      }
    } else if ((params.value || params.value == 0) && topCompare > bottomCompare) {
      if (topCompare && params.value >= topCompare) {
        return 'heatmap-cell-green';
      } else if (topCompare && medianCompare && params.value < topCompare && params.value >= medianCompare) {
        return 'heatmap-cell-yellow-green';
      } else if (bottomCompare && medianCompare && params.value >= bottomCompare && params.value < medianCompare) {
        return 'heatmap-cell-yellow';
      } else if (bottomCompare && params.value < bottomCompare) {
        return 'heatmap-cell-red';
      }
    }
  }
  return '';
};
